export async function appointmentShowUseCase(id, appointmentRepostitory) {
    const result = await appointmentRepostitory.show(id);
    
    const entity = new appointmentRepostitory.model(result.data.data.attributes);
    
    if (!entity.isValid()) {
        throw new Error("Appointment Show inválido");
    }

    return entity;
}